/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryOverviewDto } from './CategoryOverviewDto';
import {
    CategoryOverviewDtoFromJSON,
    CategoryOverviewDtoFromJSONTyped,
    CategoryOverviewDtoToJSON,
    CategoryOverviewDtoToJSONTyped,
} from './CategoryOverviewDto';

/**
 * 
 * @export
 * @interface CategoryOverviewDtoPagedResponseDto
 */
export interface CategoryOverviewDtoPagedResponseDto {
    /**
     * 
     * @type {Array<CategoryOverviewDto>}
     * @memberof CategoryOverviewDtoPagedResponseDto
     */
    items?: Array<CategoryOverviewDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CategoryOverviewDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryOverviewDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryOverviewDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the CategoryOverviewDtoPagedResponseDto interface.
 */
export function instanceOfCategoryOverviewDtoPagedResponseDto(value: object): value is CategoryOverviewDtoPagedResponseDto {
    return true;
}

export function CategoryOverviewDtoPagedResponseDtoFromJSON(json: any): CategoryOverviewDtoPagedResponseDto {
    return CategoryOverviewDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function CategoryOverviewDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryOverviewDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CategoryOverviewDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function CategoryOverviewDtoPagedResponseDtoToJSON(json: any): CategoryOverviewDtoPagedResponseDto {
    return CategoryOverviewDtoPagedResponseDtoToJSONTyped(json, false);
}

export function CategoryOverviewDtoPagedResponseDtoToJSONTyped(value?: CategoryOverviewDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CategoryOverviewDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

